export const DOCUMENTS = "documents",
             SEARCH = "search",
             PENDING_TASKS = "pendingtasks",
             FAVORITES = "favourites",
             MY_REQUEST = "documentrequests",
             CATEGORY1 = "category1",
             CATEGORY2 = "category2",
             LEDGER = "ledger",
             EXPIRY_PERIOD = "notificationperiod",
             MY_ACTIONS = "myactions",
             AUDIT_LOG = "auditlog"





